import FeaturedActivitiesBlock from "./FeaturedActivitiesBlock";

export default FeaturedActivitiesBlock;
